<template>
  <div class="photo-card">
    <div class="photo-header">
      <span class="photo-title">{{ lang('Photo') || 'Photo' }}</span>
      <small class="photo-subtitle">(minimal size 300x300px)</small>
    </div>

    <input ref="fileInput" type="file" accept="image/*" @change="onImageUpload($event)" style="display: none" />

    <div class="photo-container" @click="triggerFileInput">
      <div class="photo-frame">
        <img v-if="imageUrl" :src="imageUrl" alt="Student Avatar" class="student-image" />
        <img v-else src="../../../assets/boy.png" alt="Default Avatar" class="student-image" />
      </div>
    </div>
  </div>
</template>

<script>
import { lang } from '../../../locale'

export default {
  name: 'StudentPhotoCard',
  props: {
    imageUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    lang,
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    onImageUpload(e) {
      const file = e.target.files[0]
      if (file) {
        this.$emit('photo-uploaded', file)
      }
    },
  },
}
</script>

<style scoped>
.photo-card {
  background: #ffffff;
  border-radius: 6px;
  height: 300px;
  width: 300px;
  min-width: 300px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.photo-header {
  text-align: center;
  margin-bottom: 20px;
}

.photo-title {
  font-weight: bold;
  display: block;
  font-size: 16px;
  color: #333;
}

.photo-subtitle {
  color: #666;
  font-size: 12px;
}

.photo-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.photo-frame {
  position: relative;
  height: 180px;
  width: 180px;
}

.student-image {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e9ecef;
  transition: transform 0.3s ease;
}

.student-image:hover {
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .photo-card {
    width: 100%;
    height: auto;
    min-height: 250px;
  }

  .photo-frame {
    height: 150px;
    width: 150px;
  }
}
</style>
